exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".agAlerta{background-color:#ffe7e7}.txt-alerta{font-weight:600}.busyQueue{background-color:#e7191b;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./app/admin/consola_call/callcenter.component.css
// module id = 436
// module chunks = 0